import gql from "graphql-tag";

export const GEOCODE_DETAIL_QUERY = gql`
    query GeocodeDetail($PlaceId: String!, $searchType: String!, $geocodeType: String) {
        search {
            geocodeDetail(PlaceId: $PlaceId, searchType: $searchType, geocodeType: $geocodeType)
        }
    }
`;
